import { __extends, __assign } from 'tslib';
import React__default, { useContext } from 'react';
import { isSharedLayout, SharedLayoutContext, FramerTreeLayoutContext } from '../../../context/SharedLayoutContext.js';
import { snapshotViewportBox } from '../../../render/dom/projection/utils.js';

/**
 * This component is responsible for scheduling the measuring of the motion component
 */
var Measure = /** @class */function (_super) {
  __extends(Measure, _super);
  function Measure() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  /**
   * If this is a child of a SyncContext, register the VisualElement with it on mount.
   */
  Measure.prototype.componentDidMount = function () {
    var _a = this.props,
      syncLayout = _a.syncLayout,
      framerSyncLayout = _a.framerSyncLayout,
      visualElement = _a.visualElement;
    isSharedLayout(syncLayout) && syncLayout.register(visualElement);
    isSharedLayout(framerSyncLayout) && framerSyncLayout.register(visualElement);
    visualElement.onUnmount(function () {
      if (isSharedLayout(syncLayout)) {
        syncLayout.remove(visualElement);
      }
      if (isSharedLayout(framerSyncLayout)) {
        framerSyncLayout.remove(visualElement);
      }
    });
  };
  /**
   * If this is a child of a SyncContext, notify it that it needs to re-render. It will then
   * handle the snapshotting.
   *
   * If it is stand-alone component, add it to the batcher.
   */
  Measure.prototype.getSnapshotBeforeUpdate = function () {
    var _a = this.props,
      syncLayout = _a.syncLayout,
      visualElement = _a.visualElement;
    if (isSharedLayout(syncLayout)) {
      syncLayout.syncUpdate();
    } else {
      snapshotViewportBox(visualElement);
      syncLayout.add(visualElement);
    }
    return null;
  };
  Measure.prototype.componentDidUpdate = function () {
    var syncLayout = this.props.syncLayout;
    if (!isSharedLayout(syncLayout)) syncLayout.flush();
  };
  Measure.prototype.render = function () {
    return null;
  };
  return Measure;
}(React__default.Component);
function MeasureContextProvider(props) {
  var syncLayout = useContext(SharedLayoutContext);
  var framerSyncLayout = useContext(FramerTreeLayoutContext);
  return /*#__PURE__*/React__default.createElement(Measure, __assign({}, props, {
    syncLayout: syncLayout,
    framerSyncLayout: framerSyncLayout
  }));
}
export { MeasureContextProvider };